import React from 'react';
import * as PropTypes from 'prop-types';
import { RecordStatusFilter } from '../lib/RecordStatusFilter';

ModelStatus.propTypes = {
  model: PropTypes.object,
  allRecords: PropTypes.array,
  locale: PropTypes.string
};

function ModelStatus(props) {
  const { model, allRecords, locale } = props;

  const filteredStatuses = RecordStatusFilter(allRecords, locale);

  return (
    <div>
      <p>Model name: {model.name}</p>
      <p>Model key: {model.apiKey}</p>
      <p>Model id: {model.id}</p>
      <p>Total record count: {allRecords.length}</p>
      <p>
        Records with status Everything is approved:{' '}
        {filteredStatuses['Everything is approved'].length}{' '}
      </p>
      <p>
        Records with status Waiting for translations from CBG:
        {filteredStatuses['Waiting for translations from CBG'].length}
      </p>
      <p>Records with status Waiting for review: {filteredStatuses['Waiting for review'].length}</p>
      <p>
        Records with status Fields are missing translation(s):{' '}
        {filteredStatuses['Fields are missing translation(s)'].length}
      </p>
    </div>
  );
}

export default ModelStatus;
